import React, { useMemo, useState, useEffect } from 'react';
import FreeHandSign from './FreeHandSign';
import Formulaire from './formulaire';
import { useParams } from 'react-router-dom';

import { Stack, Divider, Box, LinearProgress, Alert } from '@mui/material';

import PdfReact from './PdfReact';

import { SpSignatureClient } from '../services/ApiClient';

const getRedirectUrl = request => {
    for (const input of request.formulaire?.inputs || []) {
        const selectedValues = request.formulaireDataResult?.[input.nomInterne] || [];
        const keyValue = input.keyValues?.find(kv => selectedValues.includes(kv.key));
        if (keyValue?.callbackUrl) {
            return keyValue.callbackUrl;
        }
    }

    return request.redirectUrl || '/AlreadySigned';
};

const Content = () => {
    const [data, setData] = useState('');
    const [pdfState] = useState(false);
    const [userData, setUserData] = useState(undefined);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadingPdf, setLoadingPDF] = useState(false);
    const [loadError, setLoadError] = useState(false);
    const { id } = useParams();
    const apiClient = useMemo(() => new SpSignatureClient((window as any).SPSignatureAPI), []);

    useEffect(() => {
        let isMounted = true;
        const pdfDelay = (window as any).LoadingPdfTimeInMs == undefined ? 1000 : (window as any).LoadingPdfTimeInMs;
        const timeout = window.setTimeout(() => {
            if (isMounted) {
                setLoadingPDF(true);
            }
        }, pdfDelay);

        apiClient.signature_GetSignatureById(id)
            .then(x => {
                if (!isMounted) {
                    return;
                }

                if (x.signatureDate) {
                    window.location.replace(getRedirectUrl(x));
                    return;
                }

                setUserData(x);
                setPdfUrl(`data:application/pdf;base64,${x.pdFile}`);
                setLoadError(false);
                setLoading(false);
            })
            .catch(ex => {
                console.log(ex);
                if (!isMounted) {
                    return;
                }

                setLoadError(true);
                setLoading(false);
            });

        return () => {
            isMounted = false;
            window.clearTimeout(timeout);
        };
    }, [apiClient, id]);

    if (loading) {
        return (
            <Box sx={{ width: '100%' }}>
                <LinearProgress />
            </Box>
        );
    }

    if (loadError || userData == undefined) {
        return (
            <Box sx={{ width: '100%', maxWidth: 720, margin: '40px auto', padding: '0 16px' }}>
                <Alert severity="error">
                    Le lien est peut-être invalide ou déjà indisponible.
                </Alert>
            </Box>
        );
    }

    return (
        <Stack spacing={1} divider={<Divider orientation="horizontal" />}>
            <div
                style={{
                    backgroundColor: '#EEF2F6',
                    width: '100vw',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                <p style={{ margin: '5%', textAlign: 'center' }}>
                    <b
                        style={{
                            fontSize: 20,
                            textAlign: 'center',
                            display: 'table-cell',
                            wordWrap: 'break-word',
                            fontWeight: '700',
                        }}>
                        {userData.texte}
                    </b>
                </p>
            </div>

            {loadingPdf && <PdfReact pdfUrl={pdfUrl} />}

            <FreeHandSign
                getData={nextData => {
                    setData(nextData);
                }}
            />

            <div>
                <Formulaire dtFromParent={{ data, pdfState, UserData: userData }} />
            </div>
        </Stack>
    );
};

export default Content;
